import styled from 'styled-components/native';
import { withDefaultTypographyProps } from '@sp/ui/typography/index.shared';

const Footnote = styled(withDefaultTypographyProps)`
  font-size: ${(props) => props.theme.FONT_SIZES.FOOTNOTE.DESKTOP}px;
`;

export default Footnote;
